import React, { useState, useEffect } from "react";
import { Column, DataGrid, Button } from "devextreme-react/data-grid";
import { api_path } from "../../shared";
import CustomStore from "devextreme/data/custom_store";
const CustomerShipperLoadDatagrid = ({ SMF_CODE }) => {
  const token = process.env.REACT_APP_API_TOKEN;
  const url = api_path + "/customer/last-shipment.php";
  const [detailDataSource, setDetailDataSource] = useState(null);
  useEffect(() => {
    if (SMF_CODE) {
      const store = new CustomStore({
        key: "DOCNO",
        load: () => {
          return fetch(`${url}?customer_code=${SMF_CODE}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
            .then((res) => {
              if (!res.ok) {
                throw new Error("Network response was not ok");
              }
              return res.json();
            })
            .catch((error) => {
              console.error("Error loading data:", error);
              return [];
            });
        },
      });
      setDetailDataSource(store);
    }
  }, [SMF_CODE]);

  return (
    <div className="">
      <br />
      <label className="head2">SMF-Shipper Load [BSE]</label>
      <DataGrid
        dataSource={detailDataSource}
        showBorders={false}
        keyExpr="DOCNO"
      >
        <Column dataField="DOCNO" />
        <Column dataField="JOBNO" />
        <Column dataField="BOOKNO" />
        <Column dataField="SALENAME" />
        <Column dataField="SHIPPERNAME" />
      </DataGrid>
    </div>
  );
};

export default CustomerShipperLoadDatagrid;
